/**
 * The access token lives only in memory. A page reload restores the session
 * through the httpOnly refresh cookie (POST /auth/refresh), never web storage.
 */
let accessToken: string | null = null;

export const tokenStore = {
  get: () => accessToken,
  set: (token: string | null) => {
    accessToken = token;
  },
};
